import { useIntl } from "react-intl";
import { ToolbarButtonAction } from "src/app/components/grid/SimpleEntityGrid";

export type TKeywordsRanklvl1GridToolbarButtons = "import" | "forbidden" | "";


const useKeywordsRanklvl1GridToolbarButtons = (
    handleModal: (modalName: TKeywordsRanklvl1GridToolbarButtons) => void
): ToolbarButtonAction => {
    const { formatMessage } = useIntl();

    return {
        add: false,
        export: true,
        active: true,
        metrics: true,
        custom: [
            {
                title: formatMessage({ id: "common.action.import" }),
                action: () => {
                    handleModal("import");
                },
                selectedRows: false,
            },
            {
                title: formatMessage({ id: "common.action.forbiddenKeywords" }),
                action: () => {
                    handleModal("forbidden");
                },
                selectedRows: false,
            },
        ],
    };
};

export default useKeywordsRanklvl1GridToolbarButtons;
